import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class SemanticQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.SEMANTIC;

  constructor(options: any = {}) {
    super(options);
  }
}
